<template>
    <div v-if="announcement" class="profile-announcement">
      <div class="announcement-content">
        <span class="announcement-emoji">{{ announcement.emoji }}</span>
        <span class="announcement-description">{{ announcement.description }}</span>
      </div>
      <div v-if="announcement.buttonState" class="announcement-button-wrapper">
        <a :href="announcement.buttonLink" class="announcement-button">
          {{ announcement.buttonText }}
        </a>
      </div>
    </div>
  </template>
  
  <script>
  import { db } from "../firebaseConfig";
  import { collection, getDocs, query, where, orderBy, limit } from "firebase/firestore";
  
  export default {
    name: "ProfileAnnouncement",
    data() {
      return {
        announcement: null,
        loading: false,
        error: null
      };
    },
    created() {
      this.fetchAnnouncement();
    },
    methods: {
      async fetchAnnouncement() {
        this.loading = true;
        try {
          const now = new Date();
          const announcementsRef = collection(db, "profileAnnouncement");
          // Query for announcements that are active and have an expiryDate greater than now.
          const q = query(
            announcementsRef,
            where("activeState", "==", true),
            where("expiryDate", ">", now),
            orderBy("expiryDate", "asc"),
            limit(1)
          );
          const querySnapshot = await getDocs(q);
          if (!querySnapshot.empty) {
            // Use the first (and only) announcement found.
            this.announcement = querySnapshot.docs[0].data();
          } else {
            // No valid announcement found; you might leave this as null to hide the widget.
            this.announcement = null;
          }
        } catch (err) {
          console.error("Error fetching announcement:", err);
          this.error = "Failed to load announcement.";
        } finally {
          this.loading = false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .profile-announcement {
    background-color: #f0ece3;
    color: #333;
    padding: 0.3rem 2rem 0.3rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #C9BF9B;
    border-radius: 15px;
    margin: 0rem 0rem 2rem 0rem;
    /*box-shadow: 0px 4px 4px #c9bf9b54;*/
  }
  
  .announcement-content {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .announcement-emoji {
    font-size: 2rem;
    margin-bottom: 5px;
    margin-right: 5px;
  }
  
  .announcement-description {
    font-size: 1rem;
  }
  
  .announcement-button-wrapper {
    margin-left: auto;
  }
  
  .announcement-button {
    padding: 0.5rem 1rem;
    background-color: #007bff;
    color: #fff;
    text-decoration: none;
    border-radius: 4px;
    transition: background-color 0.3s ease;
  }
  
  .announcement-button:hover {
    background-color: #0056b3;
  }
  </style>
  